import {
  stringifyMultilineContent,
  stringifyVariableAsEmpty,
} from "@repo/app-types/content/plaintext";
import type { JobType } from "@repo/app-types/entities/jobType";
import { renderMultilineContent } from "@repo/ui/content/renderers";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { type FC, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { OverviewBox } from "../../../../components/overviewBox.js";
import { TrainingMaterialsSlideover } from "./trainingMaterialsSlideover.js";

export interface TrainingMaterialsSectionProps {
  jobType: JobType;
}

export const TrainingMaterialsSection: FC<TrainingMaterialsSectionProps> = (
  props,
) => {
  const isEmpty = useMemo(() => {
    return !!stringifyMultilineContent(props.jobType.job_description, {
      stringifyVariable: stringifyVariableAsEmpty,
    }).match(/^\s*$/);
  }, [props.jobType.job_description]);

  const trainingMaterials = useMemo(
    () => renderMultilineContent(props.jobType.job_description),
    [props.jobType.job_description],
  );

  const [isSlideoverOpen, setIsSlideoverOpen] = useState(false);

  const handleBoxClick = () => {
    setIsSlideoverOpen(true);
  };

  const handleSlideoverClose = () => {
    setIsSlideoverOpen(false);
  };

  return (
    <div>
      <Label size={Size.SMALL} className="mb-2">
        Training materials
      </Label>

      <OverviewBox onClick={handleBoxClick}>
        <div className={twMerge("px-3 py-2", isEmpty ? "text-slate-400" : "")}>
          {isEmpty ? (
            "Add training materials"
          ) : (
            <span className="line-clamp-3">{trainingMaterials}</span>
          )}
        </div>
      </OverviewBox>

      <TrainingMaterialsSlideover
        jobType={props.jobType}
        isOpen={isSlideoverOpen}
        onRequestClose={handleSlideoverClose}
      />
    </div>
  );
};
